import { render, staticRenderFns } from "./nextYearFlowCardSecond.vue?vue&type=template&id=b98141d2&scoped=true&"
import script from "./nextYearFlowCardSecond.vue?vue&type=script&lang=js&"
export * from "./nextYearFlowCardSecond.vue?vue&type=script&lang=js&"
import style0 from "./nextYearFlowCardSecond.vue?vue&type=style&index=0&id=b98141d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98141d2",
  null
  
)

export default component.exports